import React, { useState, useEffect } from 'react'
import { Classes, Dialog, Radio, RadioGroup } from '@blueprintjs/core'
import { Button, Toaster } from '@ui'
import api, { Role } from '@api'
import { ApolloError } from 'apollo-boost'
import { getRoleLabel } from '@ui/selects/RoleSelect'

export interface RolePopupDialogProps {
  setRolePopupOpen: (para: boolean) => void
  rolePopupOpen: boolean
  selectedSpaces: string[]
  allEmployeesList: string[]
}

export default function RolePopup({
  setRolePopupOpen,
  rolePopupOpen,
  selectedSpaces,
  allEmployeesList,
}: RolePopupDialogProps) {
  const [btnDisabled, setbtnDisabled] = useState(true)
  const [selectedRole, setselectedRole] = useState('')
  const ids = allEmployeesList
  const role = selectedRole
  async function onClickSubmit() {
    Toaster.success({ message: allEmployeesList.length + ' selected employee was unseated' })
  }

  return (
    <>
      <Dialog
        isOpen={rolePopupOpen}
        style={{ width: '560px', position: 'relative' }}
        transitionDuration={200}
        isCloseButtonShown={true}
        canOutsideClickClose={false}
        title={''}
        onClose={() => setRolePopupOpen(false)}
      >
        <div className={Classes.DIALOG_HEADER}>
          <div>
            <div> Employee Role </div>
          </div>
        </div>
        <div className={Classes.DIALOG_BODY}>
          <div style={{ marginTop: 20 }}>
            <div style={{ marginTop: '15px' }}>
              <span>Assign the role based on the functionality you want the user to have:</span>
              <ul style={{ paddingLeft: '20px', paddingTop: '10px', listStyle: 'disc' }}>
                <li>Administrator: full capabilities.</li>
                <li>
                  Department Administrator: delegate responsibility over part of the organization.
                </li>

                <li>Location Admin ???</li>

                <li>IT: manage integrations with other services.</li>

                <li>Viewer: access employee and room finder (appropriate for most employees).</li>

                <li>Power Admin ???</li>

                <li>Space Captain ???</li>

                <li>Booking Manager ???</li>
              </ul>
            </div>
          </div>
          <div style={{ marginTop: 20 }}>
            {Object.values(Role).map((item, index) => (
              <div key={index}>
                <RadioGroup
                  inline
                  onChange={(event) => {
                    const val = event.currentTarget.value
                    setselectedRole(getRoleLabel(item))
                    setbtnDisabled(false)
                  }}
                  selectedValue={selectedRole}
                >
                  <Radio
                    label={`${getRoleLabel(item)}`}
                    value={`${item}`}
                    style={{ marginBottom: 'none' }}
                  />
                </RadioGroup>
              </div>
            ))}
          </div>
        </div>
        <div className={Classes.DIALOG_FOOTER} style={{ marginTop: 10 }}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              intent="primary"
              disabled={btnDisabled}
              text="Assign"
              onClick={() => onClickSubmit()}
            />

            <Button
              disabled={false}
              text="Cancel"
              onClick={() => {
                setRolePopupOpen(false)
              }}
            />
          </div>
        </div>
      </Dialog>
    </>
  )
}
